import { ChangeEvent } from 'react';

import { TagRelationsInput } from '../../tags/TagRelationsInput/TagRelationsInput';
import { LabelInput, NewRow } from '../../shared';

import { Pack } from '../../types/packTypes';

export enum PossibleOverviewFields {
    Name = 'name',
    PackId = 'packId',
    ActiveFromDate = 'activeFromDate',
    ActiveToDate = 'activeToDate',
    Worth = 'worth',
    RequiredVersion = 'requiredVersion',
}

type PackOverviewProps = {
    pack: Pack;
    onInputChange: (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        child?: string | null,
        index?: number | null,
    ) => void;
    onTagsChange: (tags: number[]) => void;
    isNew: boolean;
};

export function PackOverview(props: PackOverviewProps) {
    const { pack, isNew, onInputChange, onTagsChange } = props;

    if (!pack.type) {
        return null;
    }

    return (
        <div>
            <LabelInput
                size="wide"
                name={PossibleOverviewFields.Name}
                value={pack.name}
                tooltip="Used for import of localized pack text."
                label="String ID"
                onChange={onInputChange}
            />
            <LabelInput
                disabled={!isNew}
                size="wide"
                name={PossibleOverviewFields.PackId}
                value={pack.packId}
                tooltip="Should match Pack ID in the app, something like: pack.[playsetname]"
                label="pack id"
                onChange={onInputChange}
            />
            <NewRow />
            <LabelInput
                size="normal"
                type="datetime-local"
                name={PossibleOverviewFields.ActiveFromDate}
                value={pack.activeFromDate}
                label="Starts"
                onChange={onInputChange}
            />
            <LabelInput
                size="normal"
                type="datetime-local"
                name={PossibleOverviewFields.ActiveToDate}
                value={pack.activeToDate}
                label="Ends"
                onChange={onInputChange}
            />
            <NewRow />
            <LabelInput
                size="narrow"
                name={PossibleOverviewFields.Worth}
                value={pack.worth}
                tooltip="Price tier for the pack. Set to 0 for bundles"
                label="worth"
                onChange={onInputChange}
                type="number"
            />
            <LabelInput
                size="narrow"
                name={PossibleOverviewFields.RequiredVersion}
                value={pack.requiredVersion}
                tooltip="Shop version of the release when the pack is first available. Disables purchase in older releases."
                label="required shop version"
                onChange={onInputChange}
                type="number"
            />
            <NewRow />
            <TagRelationsInput
                label="Tags"
                value={pack.tags ?? []}
                roValue={pack.childrenTags ?? []}
                onChange={onTagsChange}
            />
        </div>
    );
}
